import React, { createContext, useContext, useRef, useState, useEffect } from "react";

const defaultCanvasValue = {
  canvas: null,
  setCanvas: () => {},
  clearCanvasState: () => {},
  backgroundColor: "#ffffff",
  setBackgroundColor: () => {},
  getBackgroundColor: () => "#ffffff",
};

export const CanvasContext = createContext(defaultCanvasValue);

const CanvasProvider = ({ children }) => {
  const [canvas, setCanvas] = useState(null);
  const [backgroundColor, setBackgroundColor] = useState("#ffffff");
  const canvasRef = useRef(null);

  // Store background color per slide
  const [slideBackgroundColors, setSlideBackgroundColors] = useState({});

  const clearCanvasState = () => {
    console.log("Clearing canvas");
    setCanvas(null);
  };

  const updateBackgroundColor = (color) => {
    setBackgroundColor(color);
    if (canvas) {
      canvas.setBackgroundColor(color, canvas.renderAll.bind(canvas));
    }
  };

  // Save the current slide's background color
  const saveSlideBackgroundColor = (slideId) => {
    setSlideBackgroundColors((prevColors) => ({
      ...prevColors,
      [slideId]: backgroundColor,
    }));
  };

  // Retrieve the background color for a specific slide
  const getBackgroundColorForSlide = (slideId) => {
    return slideBackgroundColors[slideId] || "#ffffff";
  };

  useEffect(() => {
    if (canvas) {
      canvas.setBackgroundColor(backgroundColor, canvas.renderAll.bind(canvas));
    }
  }, [backgroundColor, canvas]);

  return (
    <CanvasContext.Provider
      value={{
        canvas,
        setCanvas,
        canvasRef,
        backgroundColor,
        setBackgroundColor: updateBackgroundColor,
        clearCanvasState,
        saveSlideBackgroundColor,
        getBackgroundColorForSlide,
      }}
    >
      {children}
    </CanvasContext.Provider>
  );
};

export const MemoizedCanvasProvider = React.memo(CanvasProvider);

export const useCanvasContext = () => {
  return useContext(CanvasContext);
};
